import { useState, useEffect } from 'react';
import { ModerationReportContextType } from '../../../common/moderationTypes';
import { LoadableModerationReportModal } from './LoadableModerationReportModal';
import { useModerationReportingEnabled } from './useModerationReportingEnabled';

export const OPEN_REPORT_MODAL_EVENT = 'rio:open-report-modal';

export function openGlobalReportModal() {
  window.dispatchEvent(new Event(OPEN_REPORT_MODAL_EVENT));
}

export function GlobalReportModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const canReport = useModerationReportingEnabled();

  useEffect(() => {
    if (!canReport) {
      return;
    }

    const handler = () => {
      setHasOpened(true);
      setIsOpen(true);
    };
    window.addEventListener(OPEN_REPORT_MODAL_EVENT, handler);
    return () => window.removeEventListener(OPEN_REPORT_MODAL_EVENT, handler);
  }, [canReport]);

  if (!canReport || !hasOpened) {
    return null;
  }

  return (
    <LoadableModerationReportModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      contextType={ModerationReportContextType.OTHER}
      entityId={0}
    />
  );
}
